import { useEffect, useRef, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

export function PwaUpdatePrompt() {
  const [needsUpdate, setNeedsUpdate] = useState(false);
  const updateRef = useRef<((reload?: boolean) => Promise<void>) | null>(null);

  useEffect(() => {
    updateRef.current = registerSW({ onNeedRefresh: () => setNeedsUpdate(true) });
  }, []);

  if (!needsUpdate) return null;
  return (
    <div className="update-banner">
      <span>发现新版本，可以在安全位置更新。</span>
      <button onClick={() => void updateRef.current?.(true)}>立即更新</button>
      <button onClick={() => setNeedsUpdate(false)}>稍后</button>
    </div>
  );
}
